import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { useReactPage } from '../../hooks/useReactPage';

export const CustomLink = ({
  cypress,
  stat,
  href,
  styledLink: StyledLink,
  children,
  onClick,
  ...rest
}) => {
  // TODO: This is a temporary solution. Remove this hook after the last legacy page is converted to Next.js.
  const isReactPage = useReactPage(href);
  const Component = isReactPage ? Link : 'a';
  const onClickHandler = isReactPage ? onClick : null;

  if (!href) return null;

  // locale={false} prevents Next.js from auto-prefixing hrefs with locale
  // This is needed because we use subdomain-based routing (ru.bina.az)
  // and middleware rewrites, not path-based locale prefixes
  const localeProps = isReactPage ? { locale: false } : {};

  if (!StyledLink) {
    return (
      <Component
        href={href}
        data-cy={cypress}
        data-stat={stat}
        onClick={onClickHandler}
        {...localeProps}
        {...rest}
      >
        {children}
      </Component>
    );
  }

  return (
    <StyledLink
      as={Component}
      href={href}
      data-cy={cypress}
      data-stat={stat}
      {...localeProps}
    >
      {children}
    </StyledLink>
  );
};

CustomLink.propTypes = {
  cypress: PropTypes.string,
  stat: PropTypes.string,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  styledLink: PropTypes.elementType,
  children: PropTypes.node
};
